<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <navbar-component></navbar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->

        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    SO Upload
                  </h6>
                  <button
                    class="btn btn-success btn-xs float-end"
                    @click="downloadData"
                    type="button"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} Template
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <!-- <div v-if="isLoading" class="d-flex align-items-center">
                      <div
                        class="spinner-border ms-auto"
                        role="status"
                        aria-hidden="true"
                      ></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div> -->
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                    enctype="multipart/form-data"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Warehouse Id</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchFulfillment"
                          v-model="fulfillmentSo"
                          label="code"
                          return-object
                          @search="asyncSearchFulfillment"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>

                        <div v-if="errors.fulfillment_center_id">
                          <div
                            v-for="error in errors.fulfillment_center_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Company Id</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchCustomer"
                          v-model="customer"
                          label="code"
                          return-object
                          @search="asyncCustomer"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>

                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >So Type</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <multiselect
                          @search-change="asyncLoadSoType"
                          v-model="soType"
                          :custom-label="customType"
                          :options="fetchSoType"
                          track-by="code"
                        >
                          <span slot="noResult"
                            >Oops! No elements found. Consider changing the
                            search query.</span
                          >

                        </multiselect>

                        <!-- <v-select
                          :options="fetchSoType"
                          v-model="soType"
                          label="name"
                          return-object
                          @search="asyncLoadSoType"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select> -->
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >File</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="file"
                          ref="file"
                          class="form-control"
                          @change="handleFileUpload($event)"
                        />

                        <div v-if="errors.code">
                          <div
                            v-for="error in errors.code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3" v-if="tableError">
                      <div class="col-lg-2"></div>
                      <div class="col-lg-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>{{ $t("lineNo") }}</th>
                              <th>{{ $t("statusTxt") }}</th>
                              <th>{{ $t("messageTxt") }}</th>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, index) in errorsData"
                                :key="index"
                              >
                                <th>{{ row.docNo }} {{ row.lineNo }}</th>
                                <th>{{ row.status }}</th>
                                <th>{{ row.remarks }} {{ row.message }}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
  <script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import multiselect from "vue-multiselect";
export default {
  name: "SOUpload",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
        multiselect,
  },
  data() {
    return {
      tableError: false,
      errorsData: [],
      file: "",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      regionCode: "",
      forms: { name: "", usernmae: "" },
      fetchFulfillment: [],
      fulfillmentSo: null,
      fetchSoType: [],
      soType: null,
      fetchCustomer: [],
      customer: null,
    };
  },
  watch: {},
  methods: {
    customType(ev){
      return `${ev.code} | ${ev.name}`
    },
    loadSoType() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=SO_TYP";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncLoadSoType(ev) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=SO_TYP&code=" +
        ev;
      this.fetchSoType = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadFullfilment() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/fulfillment/get-data-fulfillment?code=" +
        ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadCustomer() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/customer/get-data-company-oms?code=" +
        code;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    downloadData() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/so/download-template-order?downloadTemplateOrder=downloadTemplateOrder";

      var file_name = "template_so.xlsx";

      //var columnFilters = this.serverParams.columnFilters;

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "SoController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_upload) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/flux-oms/so-outbound";
    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);

          let formData = new FormData();
          console.log(this.file);
          formData.append("file", this.file);
          formData.append(
            "fulfillment_center_id",
            this.fulfillmentSo?.fulfillment_center_id
              ? this.fulfillmentSo?.fulfillment_center_id
              : ""
          );
          formData.append(
            "customer_id",
            this.customer?.customer_id ? this.customer?.customer_id : ""
          );
          formData.append(
            "orderType",
            this.soType?.code ? this.soType?.code : ""
          );

          const baseURI = this.$settings.endPointFluxOms + "v2/so/upload";
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status == 200) {
                this.errors = [];
                this.tableError = true;
                this.errorsData = response.data.datas;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
              // if (response.data.status == 200) {
              //   this.resetForm();
              //   this.errors = [];
              //   this.tableError = true;
              //   this.errorsData = response.data.datas;
              //   // //console.log(response.data.datas.user_id);
              //   // //var params = this.$onRandom(response.data.datas.region_id);
              //   // window.location.href = "/flux-oms/so-outbound";
              //   // // this.success('Berhasil');
              // } else {
              //   this.errors = response.data.errors;
              //   this.resultError(response.data.errors);
              // }
            })
            .catch((error) => {
              this.loading();
              // if (error.response) {
              // if(error.response.status === 422) {
              //         this.errors = error.response.data.errors;
              //         this.resultError(error.response.data.errors);
              // }else if (error.response.status === 500) {
              //     this.$router.push('/server-error');
              // }else{
              //     this.$router.push('/page-not-found');
              // }
              // }
              // this.resetForm();
              this.tableError = true;
              if (error.response) {
                if (error.response.status === 422) {
                  this.errorsData = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadFullfilment();
    this.loadSoType();
    this.loadCustomer();
  },
};
</script>
  <style scoped>
</style>